import React from 'react';
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import MyContainer from "../MyContainer";
import { useI18n } from "../../i8n/useI18n";

const ImprintPage = () => {
    const { t } = useI18n();

    return (
        <MyContainer>
            <Helmet>
                <title>{t("imprintText.title")} | {t("brand.name")}</title>
            </Helmet>
            <Box sx={{ maxWidth: 720, py: 4 }}>
                <Typography variant="h2" sx={{ mb: 4 }}>{t("imprintText.title")}</Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>Angaben gemäß § 5 TMG</Typography>
                <Typography variant="body2" sx={{ mb: 0.5 }}>{t("imprintText.companyName")}</Typography>
                <Typography variant="body2" sx={{ mb: 0.5 }}>{t("imprintText.address")}</Typography>
                <Typography variant="body2" sx={{ mb: 0.5 }}>{t("imprintText.representative")}</Typography>
                <Typography variant="body2" sx={{ mb: 0.5 }}>{t("imprintText.registerNote")}</Typography>
                <Typography variant="body2" sx={{ mb: 4 }}>{t("imprintText.vatId")}</Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("imprintText.contactTitle")}</Typography>
                <Typography variant="body2">
                    Telefon: <Typography component="a" href={`tel:${t("imprintText.phone")}`} sx={{ color: "primary.main" }}>{t("imprintText.phone")}</Typography>
                </Typography>
                <Typography variant="body2" sx={{ mb: 4 }}>
                    E-Mail: <Typography component="a" href={`mailto:${t("imprintText.email")}`} sx={{ color: "primary.main" }}>{t("imprintText.email")}</Typography>
                </Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("imprintText.responsibleTitle")}</Typography>
                <Typography variant="body2" sx={{ mb: 4 }}>{t("imprintText.responsibleName")}</Typography>

                <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>{t("imprintText.disclaimerTitle")}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                    {t("imprintText.disclaimerText")}
                </Typography>
            </Box>
        </MyContainer>
    );
};

export default ImprintPage;
